import { formatPrice } from '@/helpers/priceFormat'

export default {
	install(app) {
		app.config.globalProperties.$tp = formatPrice
	},
}
